module.exports = __webpack_public_path__ + "static/media/1225576.2d1c31ac.svg";